module.exports = __webpack_public_path__ + "media/images/athletes/3199-dc8eae8e4da1d9ac131499e56308b225.png";